<template>
  <div class="people-edit-page">
    <Button type="primary" icon="ios-arrow-back" @click="back">{{$t("People.Return_to_People_list")}}</Button>
    <Card class="edit-card">
        <div style="text-align:center">
          <h4>{{title}}</h4>
          <Form class="edit-form" :label-width="100">
            <FormItem :label="$t('People.workNo')">
              <Input class="info" v-model="workNo" :placeholder="$t('People.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('People.name')">
              <Input class="info" v-model="name" :placeholder="$t('People.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('People.sex')">
              <Select class="info" v-model="sex" :value="sex">
                <Option :value="Number(1)" :key="Number(1)">男</Option>
                <Option :value="Number(2)" :key="Number(2)">女</Option>
              </Select>
            </FormItem>
            <!-- <FormItem label="工种">
              <Select class="info" multiple v-model="workType" :value="workType">
                <Option v-for="item in workTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select> -->
            </FormItem>
            <FormItem :label="$t('People.phone')">
              <Input class="info" v-model="phone" :placeholder="$t('People.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('People.entryTime')">
              <!-- <Input class="info" v-model="entryTime" :placeholder="$t('People.please_enter')"></Input> -->
              <DatePicker class="info" @on-change="entryTimeChange" :value="entryTime" :placeholder="$t('People.please_enter_date')"></DatePicker>
            </FormItem>
            <FormItem :label="$t('People.qq')">
              <Input class="info" v-model="qq" :placeholder="$t('People.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('People.wechat')">
              <Input class="info" v-model="wechat" :placeholder="$t('People.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('People.working')">
              <Select class="info" v-model="working" :value="working">
                <Option :value="Number(1)" :key="Number(1)">{{$t("People.yes")}}</Option>
                <Option :value="Number(0)" :key="Number(0)">{{$t("People.no")}}</Option>
              </Select>
            </FormItem>
            <hr>
            <div class="save-btn"><Button type="primary" @click="save()">{{$t("People.save")}}</Button></div>
          </Form>
        </div>
    </Card>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'PeopleEdit',
  data () {
    return {
      id: 0,
      username: '',
      role: '',
      workNo: '',
      name: '',
      sex: 0,
      workType: [],
      phone: '',
      qq: '',
      wechat: '',
      entryTime: '',
      working: 1,
      workTypeList: []
    }
  },
  computed: {
    title () {
      return this.$t('People.edit_People')
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    save () {
      let people = {
        id: this.id,
        username: this.username,
        workNo: this.workNo,
        name: this.name,
        sex: this.sex,
        workType: this.workType,
        phone: this.phone,
        qq: this.qq,
        role: Number(this.role),
        wechat: this.wechat,
        entryTime: this.entryTime,
        working: this.working
      }
      Api.people.save(people).then(() => {
        this.$router.push({'name': 'PeopleList'})
      })
    },
    entryTimeChange (v) {
      this.entryTime = v
    }
  },
  mounted () {
    Api.workType.list().then(res => {
      this.workTypeList = res.workTypes
    })
  },
  beforeRouteEnter (to, from, next) {
    let id = Number(to.params.id)
    if (id !== 0) {
      Api.people.get(id).then(res => {
        let p = res.account
        next(vm => {
          vm.id = p.id
          vm.workNo = p.workNo
          vm.name = p.name
          vm.sex = p.sex
          if (p.workType !== null) {
            vm.workType = p.workType
          }
          vm.role = p.role
          vm.username = p.username
          vm.phone = p.phone
          vm.qq = p.qq
          vm.wechat = p.wechat
          vm.entryTime = p.entryTime
          vm.working = p.working
        })
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
  .people-edit-page {
    padding: 10px;
  }
  .edit-card {
    margin-top: 20px
  }
  .edit-form {
    padding: 20px 0px;
    text-align: left;
  }
  .edit-form .info {
    width: 33.33333%
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
  .save-btn {
    text-align: left;
  }
</style>





// WEBPACK FOOTER //
// Edit.vue?09be2881